import { useEffect, useState } from "react";
import { Box, Grid, OutlinedInput } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import { filter } from "lodash";

import { HeroText } from "components/shared/Typography";
import RightContent from "components/wrappers/RightContent";
import useApp, { ProductLevel } from "hooks/useApp";
import { colors } from "theme";
import { IAssignedUser, UserRole, UserRoleFilter } from "types/user";

import { DataTable } from "./components/DataTable";
import { FilterGroup } from "./components/FilterGroup";

const useStyles = makeStyles({
  extSearchField: {
    "& > .MuiInputBase-input::placeholder": {
      color: colors.grey[100],
      fontSize: 12,
      opacity: 1,
    },
  },
});

export const Users = () => {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filteredRows, setFilteredRows] = useState<IAssignedUser[]>([]);
  const [rowsData, setRowsData] = useState<IAssignedUser[]>([]);
  const { productLevel } = useApp();

  const [activeFilter, setActiveFilter] = useState<UserRoleFilter>(
    UserRoleFilter.All
  );

  const getFilteredData = () => {
    let newFilteredRows = [...rowsData];

    switch (activeFilter) {
      case UserRoleFilter.Customer:
        newFilteredRows = [
          ...filter(
            newFilteredRows,
            (item: IAssignedUser) => item.role === UserRole.Customer
          ),
        ];
        break;
    }
    setFilteredRows(newFilteredRows);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [activeFilter]);

  useEffect(() => {
    getFilteredData();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [rowsData]);

  return (
    <RightContent>
      <Grid container justifyContent="space-between">
        <Grid item xs={productLevel !== ProductLevel.MVP ? 8 : 12}>
          <HeroText>Your List of Assigned Users</HeroText>
        </Grid>
        {productLevel !== ProductLevel.MVP && (
          <Grid item xs={4}>
            <OutlinedInput
              fullWidth
              placeholder="Search Users"
              aria-label="Search for Users in the user table"
              endAdornment={<SearchIcon />}
              className={classes.extSearchField}
            />
          </Grid>
        )}
      </Grid>

      <Box my={{ xs: 2, sm: 3 }}>
        <FilterGroup
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          data={filteredRows}
        />
      </Box>

      <DataTable
        currentPage={currentPage}
        filteredRows={filteredRows}
        setCurrentPage={setCurrentPage}
        setRowsData={setRowsData}
      />
    </RightContent>
  );
};
